import { render } from "./DatasetTile.vue?vue&type=template&id=3091ed03&scoped=true"
import script from "./DatasetTile.vue?vue&type=script&lang=js"
export * from "./DatasetTile.vue?vue&type=script&lang=js"

import "./DatasetTile.vue?vue&type=style&index=0&id=3091ed03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3091ed03"]])

export default __exports__